import { Account } from '@libs/src/models/account.model';
import { USER_ONBOARDING_ROUTE_PATHS } from '@main-client/src/app/user-onboarding/user-onboarding.helper';
import { filterVisibleGroups } from '@main-client/src/app/user/user.helpers';

export function getNewAccountRedirectParams(
  userProfile: Account,
  groupId?: string,
) {
  const userGroupMemberships = filterVisibleGroups(userProfile.groups);
  const firstGroupId = userGroupMemberships[0]?.document?._id || null;
  const onboardingPath = firstGroupId
    ? USER_ONBOARDING_ROUTE_PATHS.hubSegments
    : USER_ONBOARDING_ROUTE_PATHS.hubs;
  return {
    path: ['/get-started', onboardingPath],
    queryParams: { preregistrationGroupId: groupId || firstGroupId },
  };
}
